import parse from "html-react-parser";

// Inventory HTML contains the availability indicator first, followed by stock details.
export const splitInventoryContent = (inventory) => {
    const html = inventory?.content?.html;
    if (!html) return { availability: null, details: [] };

    const parsed = parse(html);
    const nodes = (Array.isArray(parsed) ? parsed : [parsed]).filter((node) => node && (typeof node !== "string" || node.trim()));

    return {
        availability: nodes[0] ?? null,
        details: nodes.slice(1),
    };
};
